import * as _ from "lodash";
import * as React from "react";
import * as S from "@styled";

import { IValueLabel } from "../../model/ITriggerData";
import { CallActivityEditorProps } from "./CallActivityEditor";
import TriggerInput, { InputMode } from "../Triggers/TriggerInput";
import CallActivityRemoteExecutionEditorInput from "./CallActivityRemoteExecutionEditorInput";
import { ParameterEditorValue } from "processEditor/model/ParameterEditorValue";
import { ParameterEditorMode } from "../ParameterInput";

export const timeoutMinutesParameterName = "__timeoutMinutes";
export const remoteCallParameterName = "__isRemoteCall";
export const remoteCallDictionaryName = "__remoteCallDestinations";

export class RemoteExecutionEditor extends React.Component<CallActivityEditorProps, {}> {
    private readonly defultRemoteTimeoutMinutes = 30;
    constructor(props: CallActivityEditorProps) {
        super(props);
        this.state = {};
    }

    public componentDidMount() {
        // verify that all environments has a set agent group if it's a remote call
        if (_.has(this.props.existingParameters, remoteCallParameterName) && _.get(this.props.existingParameters, remoteCallParameterName) === true) {
            if (!_.has(this.props.existingParameters, timeoutMinutesParameterName) && this.props.onValueMissing) {
                this.props.onValueMissing(timeoutMinutesParameterName, this.defultRemoteTimeoutMinutes);
            }
        }
    }

    public hasExpressionModes() {
        if (!_.has(this.props.existingParameters, remoteCallParameterName) || !_.has(this.props.existingParameters, remoteCallDictionaryName)) {
            return;
        }

        const environments = _.uniqBy(this.props.agentGroups, (a) => a.environment);
        const remteCallDestinations: Record<string, ParameterEditorValue | null> = _.get(this.props.existingParameters, remoteCallDictionaryName);
        const hasExpressionModes = environments
            .some((s) => {
                const value: ParameterEditorValue | null = _.get(remteCallDestinations, s.environment);
                if (value?.mode === ParameterEditorMode[ParameterEditorMode.csharp]) {
                    return true;
                }
            });

        return hasExpressionModes;
    }

    public render() {
        let value = _.get(this.props.existingParameters, remoteCallParameterName);
        if (value == null) {
            value = false;
        }
        const isRemoteCall = value as boolean;

        let environmentAgentGroupSelection: JSX.Element | null = null;
        if (isRemoteCall) {
            environmentAgentGroupSelection = <div>
                <TriggerInput
                    key={timeoutMinutesParameterName}
                    name={timeoutMinutesParameterName}
                    label={FRENDS.Localizations.TimeoutMinutes}
                    defaultValue={this.defultRemoteTimeoutMinutes}
                    existingParameters={this.props.existingParameters}
                    inputMode={InputMode.number}
                    elementId={this.props.id}
                />
                {this.hasExpressionModes() && (
                    <S.WarningContainer>
                        <div className="alert-warning">
                            <div className="alert-label">Agent group validation</div>
                            <div className="alert-content">Some target Agent groups use expression mode and Frends will not validate them. Remember to deploy the Subprocess to the Agent group.</div>
                        </div>
                    </S.WarningContainer>
                )}
                {
                    _.uniqBy(this.props.agentGroups, (a) => a.environment).map((e) => {
                        const agentGroups = this.getAgentGroupSelectionsForEnvironment(e.environment);
                        const identifier = remoteCallDictionaryName + "." + e.environment
                        return (
                            <CallActivityRemoteExecutionEditorInput
                                key={identifier}
                                label={FRENDS.Localizations.SubprocessExecuteOnAgentGroupForEnvironment + " " + e.environmentDisplayName}
                                agentGroups={agentGroups}
                                environmentName={e.environment}
                                environmentDisplayName={e.environmentDisplayName}
                                elementId={this.props.id}
                                identifier={identifier}
                            />
                        );
                    })
                }
            </div>;
        }
        return <div>
            <TriggerInput
                key={remoteCallParameterName}
                name={remoteCallParameterName}
                label={FRENDS.Localizations.RemoteCall}
                existingParameters={this.props.existingParameters}
                inputMode={InputMode.boolean}
                elementId={this.props.id}
            />
            {environmentAgentGroupSelection}
        </div>;
    }

    private getAgentGroupSelectionsForEnvironment(environment: string): IValueLabel[] {
        const ret: IValueLabel[] = [];
        ret.push({ value: "", label: "" }); // set first entry as empty, it is used as default
        this.props.agentGroups?.filter((a) => a.environment === environment).map((a) => {
            const label: IValueLabel = { value: a.name, label: a.displayName || a.name };
            ret.push(label);
        });
        return ret;
    }
}
